import { createAbsoluteUrl } from "@/service/url";
import { createPath } from "@/service/routing/routing";
import { resolveAuthorPrefix } from "@/service/text/prefix";
import { getFullImageUrl } from "@/service/image/image-uploaded";

// Autor artykułu i `mainEntity` jego `ProfilePage` mają ten sam `@id`, więc Google łączy treść z profilem autora.
export const profileEntity = (profile: ProfileVM) => {
  const profileUrl = profile.slug
    ? createAbsoluteUrl(createPath("author.show", { slug: profile.slug }))
    : undefined;

  return {
    "@type": profile.type === "company" ? "Organization" : "Person",
    "@id": profileUrl ? `${profileUrl}#profile` : undefined,
    name: resolveAuthorPrefix(profile.prefix, profile.name),
    url: profileUrl,
  };
};

// Pełny opis osoby/firmy: `mainEntity` na stronie autora i karty zespołu na /redakcja.
export const profileDetailsEntity = (profile: ProfileVM) => ({
  ...profileEntity(profile),
  description: profile.description || undefined,
  image: profile.image ? getFullImageUrl(profile.image) : undefined,
  email: profile.email || undefined,
  sameAs: [
    profile.web,
    profile.facebook,
    profile.twitter,
    profile.instagram,
  ].filter((link): link is string => Boolean(link)),
});
